import { MultupleListItem, PartItem, ServiceItem } from "./Common"

export interface QuoteImageItem{
	uuid: string,
	url: string,
	datasrc?: any
}

export enum QuoteSections {
	IMAGE_UPLOADS = 'IMAGE_UPLOADS',
	ADDITIONAL_DETAILS = 'ADDITIONAL_DETAILS',
	QUOTE_SERVICES = 'QUOTE_SERVICES'
}

export enum AttributesInputTypes {
	FREE_TEXT = 1,
	SINGLE_SELECTION,
	MULTIPLE_SELECTION
}

export interface DeviceAttributeslItem {
	device_attribute_id: number,
	device_attribute_title: string,
	images: QuoteImageItem[] | string[]
	value: string | string[],
	is_mandatory: boolean,
	type: number,
	options: MultupleListItem[] | string[]
}

export interface QuoteCustomerDeviceAttributes {
	title: string,
	customer_device_id: number,
	attributes: DeviceAttributeslItem[] | null
}

export interface QuoteService extends ServiceItem{
	price: string,
	uuid: string
}

export interface QuotePart extends PartItem {
	price: string,
	sku?: string,
	uuid: string
}

export interface QuoteDevice {
	services: QuoteService[],
	parts: QuotePart[],
	customerDeviceId: number
}

export enum QuoteMode {
	SERVICES = "SERVICES",
	IMAGES = "IMAGES"
}

export interface CheckListDetailItem {
	checklist_item_id: number,
	title: string,
	images: QuoteImageItem[] | string[],
	note: string
}

export interface DeviceCheckList {
	customer_device_id: number,
	checklist_id: number,
	checklist_details: CheckListDetailItem[]
}

export interface JobChecklist {
	pre: DeviceCheckList[],
	post: DeviceCheckList[]
}

export enum CHECKLIST_TYPES {
	PRE_VISIT = 'PRE_VISIT',
	POST_VISIT = 'POST_VISIT'
}

export interface PriceIngredient {
	serviceId: number,
	deviceId: number,
	customerDeviceId: number,
	title: string,
	price: number,
	isAutoAdded: boolean, 
	baseTypeId: number,
	sku?: string,
}

export interface ComputeData {
	totalPrice: number,
	tax: number,
	ingredients: PriceIngredient[]
}

export interface QuoteState {
	jobImages: QuoteImageItem[],
	propertyImages: QuoteImageItem[],
	attributes: QuoteCustomerDeviceAttributes[],
	quoteDevices: QuoteDevice[],
	in_edit_mode: boolean,
	mode: QuoteMode,
	quoteImages: QuoteImageItem[],
	checklist: JobChecklist | null,
	computeData: ComputeData | null
}
